module.exports = __webpack_public_path__ + "static/img/14xiangxiang.35146a5c.gif";